import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { useUserPlanAccess } from '@/hooks/useCompanyPlans';

interface SystemAccessDisplayProps {
  userId: string;
  companyId?: string;
}

export function SystemAccessDisplay({ userId, companyId }: SystemAccessDisplayProps) {
  const { data: systemAccess = [], isLoading, error } = useUserPlanAccess(userId, companyId);

  console.log('🎯 SystemAccessDisplay:', { userId, companyId, systemAccess, isLoading, error })

  if (isLoading) {
    return (
      <div className="flex items-center gap-1">
        <div className="w-3 h-3 bg-muted animate-pulse rounded"></div>
        <span className="text-sm text-muted-foreground">Carregando sistemas...</span>
      </div>
    );
  }

  if (error) {
    console.error('❌ SystemAccessDisplay error:', error)
    return (
      <span className="text-sm text-destructive">Erro ao carregar sistemas</span>
    );
  }

  if (!systemAccess || systemAccess.length === 0) {
    return (
      <span className="text-sm text-muted-foreground">Sem acesso a sistemas</span>
    );
  }

  const getSystemColor = (systemCode: string) => {
    switch (systemCode) {
      case 'FLEET':
        return 'hsl(var(--chart-1))';
      case 'CONTRACTS':
        return 'hsl(var(--chart-2))';
      case 'FISCAL':
        return 'hsl(var(--chart-3))';
      default:
        return 'hsl(var(--muted-foreground))';
    }
  };

  return (
    <TooltipProvider>
      <div className="flex items-center gap-1 flex-wrap">
        {systemAccess.map((access) => (
          <Tooltip key={access.system_id}>
            <TooltipTrigger asChild>
              <Badge 
                variant="outline"
                className="text-xs font-medium cursor-help"
                style={{
                  borderColor: getSystemColor(access.system_code),
                }}
              >
                {access.system_code}
              </Badge>
            </TooltipTrigger>
            <TooltipContent>
              <div className="text-sm">
                <div className="font-medium">{access.system_name}</div>
                <div className="text-muted-foreground">Plano: {access.plan_name}</div>
              </div>
            </TooltipContent>
          </Tooltip>
        ))}
      </div>
    </TooltipProvider>
  );
}